var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'settings-view',
  _vm.$arMediaQuery.pageContent.maxWidth('md') && 'md-max' ]},[_c('div',{staticClass:"title-section"},[_c('ar-text',{attrs:{"size":"lg","text":"Account Settings"}})],1),_vm._v(" "),_c('am2-tabs',{style:({
      marginTop: '22px',
    }),attrs:{"selected-tab-index":_vm.selectedPageItemIdx,"items":_vm.filteredPageItems},on:{"select":_vm.handlePageItemSelect}}),_vm._v(" "),_c('ar-divider'),_vm._v(" "),_c('nuxt-child',{staticClass:"child-content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }